import { updateSignature } from '@features/auth/auth.slice';
import { useSaveSignatureMutation, useUploadFileMutation, useGetSignatureMutation, GetSignatureResponse } from '@services';
import { transformSignatureToFile } from '@utils';
import { showToast } from '@design-system';
import { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import SignatureCanvas from 'react-signature-canvas';

export const useSignatureUpdatePageVM = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [isEmpty, setIsEmpty] = useState<boolean>(true);
    const [previousSignature, setPreviousSignature] = useState<GetSignatureResponse>();
    const [signatureDate] = useState<string>('');
    const [showConfirmationModal, setShowConfirmationModal] = useState(false);
    const signatureCanvasRef = useRef<SignatureCanvas>(null);

    const [
        saveSignature,
        { isError: isSaveSignatureError, error: saveSignatureError, data: saveSignatureData, isSuccess: isSaveSignatureSuccess }
    ] = useSaveSignatureMutation();

    const [getSignature, { data: getSignatureData }] = useGetSignatureMutation();

    const [uploadFile, { isError: isFileUploadError, error: fileUploadError, data: fileUploadData }] = useUploadFileMutation();

    useEffect(() => {
        getSignature();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(() => {
        if (getSignatureData) {
            setPreviousSignature(getSignatureData);
        }
    }, [getSignatureData]);
    useEffect(() => {
        if (isFileUploadError && fileUploadError) {
            console.error('fileUploadError:', fileUploadError);
        }
        if (fileUploadData) {
            saveSignature({ signature: fileUploadData.original });
        }
    }, [fileUploadData, isFileUploadError, fileUploadError, saveSignature]);

    useEffect(() => {
        if (isSaveSignatureError && saveSignatureError) {
            console.error('saveSignatureError:', saveSignatureError);
        }
        if (isSaveSignatureSuccess && saveSignatureData && fileUploadData) {
            dispatch(updateSignature(fileUploadData.original));
            showToast({
                message: 'Votre signature est correctement enregistrée',
                type: 'success'
            });

            navigate('/home');
        }
    }, [saveSignatureData, isSaveSignatureError, saveSignatureError, isSaveSignatureSuccess, fileUploadData, dispatch, navigate]);

    const handleSaveSignature = () => {
        if (signatureCanvasRef.current) {
            const isEmpty = signatureCanvasRef.current.isEmpty();
            if (isEmpty) {
                showToast({
                    message: 'Veuillez dessiner votre signature avant de continuer',
                    type: 'error'
                });
                return;
            }

            const dataUrl = signatureCanvasRef.current.toDataURL('image/png');
            const file = transformSignatureToFile(dataUrl);

            const formData = new FormData();
            formData.append('file', file);

            uploadFile(formData);
        }
    };

    const handleClearSignature = () => {
        if (signatureCanvasRef.current) {
            signatureCanvasRef.current.clear();
            setIsEmpty(true);
        }
    };

    const handleConfirmSave = () => {
        handleSaveSignature();
        setShowConfirmationModal(false);
    };

    return {
        signatureCanvasRef,
        handleSaveSignature,
        handleClearSignature,
        isEmpty,
        setIsEmpty,
        previousSignature,
        signatureDate,
        showConfirmationModal,
        setShowConfirmationModal,
        handleConfirmSave
    };
};
